"use client" 
import Link from "next/link"
import Loading from "../Atoms/Alerts/Loading"
const AvatarImage = ({data, module, size, hoverable=false, isAnonymous, isDeleted, background=false}) => { 

     
     // console.log("DATA@AVATAR", data)
   
     /*
     Note: users use the modern directory pattern : user_{user-uuid},
     whereas organizations use the old pattern : org_{org-id}_{org-uuid}
     */
     
     // Prioritizes hosted image instead of external url (hot link)
     //  http://localhost:3000/people-files/person_4_6d1245a0-0c7a-4499-a43a-77878b22567c/images/5bbc422e059eb_Aa8795c34fe5176d034021b3158f09b8.png 

     let entityType
     switch (module) {
          case 'ORGANIZATION':
               entityType = 'organization'
               break;
          case 'USER':
               entityType = 'user'
               break;
          case 'JOBS':
               entityType = 'job'
               break;
          case 'TALENT':
               entityType = 'talent'
               break;
          default:
               break;
     }

     const getImageSource = () => {
          if (!data){return;}
          // http://localhost:3000/org-assets/org_86_a1a6a14a-7acd-4c7f-a4b6-be9415964ad7/org_86_logo.jpg
          // let wndow = window
          // const host = wndow?.location.host.includes('localhost') ? 'http://localhost:3000' : 'https://talentive.com'
          if (data.organization_avatar_file) {
               return URL.createObjectURL(data.organization_avatar_file);
           }

          else if (data.organization_avatar) { 

               // if (entityType === 'organization'){
                    // return `/assets/organizations/org_${data.id}_${data.organization_uuid}/${data.organization_avatar}`
                    return `/assets/organizations/organization_${data.organization_uuid}/${data.organization_avatar}`
               // }
               // else if (entityType === 'company'){
               //      return `${host}/${module.toLowerCase()}-files/${entityType}_${data.id}_${data.company_uuid}/images/${data.company_uuid}__${data.avatar_file_name}`
               // }
               // else if (entityType === 'job'){
               //      return `${host}/${module.toLowerCase()}-files/${entityType}_${data.id}_${data.job_uuid}/images/${data.job_uuid}__${data.avatar_file_name}`
               // }
            
          }


          else if (isAnonymous) { 
               // return `https://upload.wikimedia.org/wikipedia/commons/5/52/Font_Awesome_5_solid_user-secret.svg`
                return `https://api.dicebear.com/8.x/identicon/svg?seed=${data.user_uuid}?randomizeIds=true`
          }
          else if (isDeleted) {
               return `https://icons.iconarchive.com/icons/fa-team/fontawesome/256/FontAwesome-User-Slash-icon.png`
          }
          else if (data.user_avatar_file){
               return URL.createObjectURL(data.user_avatar_file);
          }

          else if (data.user_avatar){
     
               // the hacky way to get user avatar from smallSocialCard.js. The api returns user_data even when the *actor* is an organization. This will be refactored later.
               if (data.user_avatar.includes('organization')) { 
                     return `/assets/organizations/organization_${data.user_uuid}/${data.user_avatar}`
               }
               else {
                    if (entityType === 'user') {
                         return `/assets/users/user_${data.user_uuid}/${data.user_avatar}`
                    }
               }
          }
/*=====
For dicebear I'll be using user initials for avatars for users that don't have a profile picture. Should I choose the electric theme, muted theme, bold pop, pastel wall or default? 
Electric is: backgroundColor=ff2e88,00e5ff,ffe600,7cff00,ff6a00,b400ff (it's diff colors for the initials)
Bold pop is: backgroundColor=ff5d8f,ffb703,43aa8b,4d96ff,b57bff
Pastel wall is: backgroundColor=ffe3ea,e3edff,e2f5e9,fdf1d4,efe6ff
Muted is: backgroundColor=6b705c,a5a58d,b98b73,7c9082,8e9aaf,9c6b58

Reminder: Talnet is a split + social network built for recruiters.

Now, Talnet is black text, white or very light slate (tailwind slate-50) background, and accent colour is : #5FEAD4
===*/
          else if (data.user_avatar === null) {
               const electric = `ff2e88,00e5ff,ffe600,7cff00,ff6a00,b400ff`
               const boldPop = `ff5d8f,ffb703,43aa8b,4d96ff,b57bff`
               const pastelWall = `ffe3ea,e3edff,e2f5e9,fdf1d4,efe6ff`
               const muted = `6b705c,a5a58d,b98b73,7c9082,8e9aaf,9c6b58`
               const talnetAccent = '5FEAD4'
               const greyScale = `343437,5e5e62,8c8c90,b6b6b9`
               // const textColor = '2ED4BF' || talnetAccent
               const textColor = talnetAccent;
               const twSlate400to700 = '94A3B8,64748B,475569,334155'
               const twSlate300to600 = 'CBD5E1,94A3B8,64748B,475569'
               const twSlate400to600 = '94A3B8,64748B,475569'
               const customBGColor1 = 'E2E8F0'

               return `https://api.dicebear.com/10.x/initials/svg?seed=${data.user_first_name}%20${data.user_last_name}&backgroundColor=${twSlate400to600}&${textColor && `textColor=${textColor}`}&randomizeIds=true&lettersVariant=double:1`
          }

          // else if (data.job_organization_avatar){
          //       return `/assets/orgs/org_${data.job_organization_id}_${data.job_organization_uuid}/${data.job_organization_avatar}`
          // }
          
          else if (data.avatar_file_url) {
               return data.avatar_file_url
          }
          else if (data.talent_pseudonym){
                return `https://api.dicebear.com/8.x/identicon/svg?seed=${data.talent_pseudonym}?randomizeIds=true`
          }
          else {
               if (module === 'ORGANIZATION'){
                    
                    // return (`../../../icons/building-small.png`)
                    
                    const electric = `ff2e88,00e5ff,ffe600,7cff00,ff6a00,b400ff`
                    const boldPop = `ff5d8f,ffb703,43aa8b,4d96ff,b57bff`
                    const pastelWall = `ffe3ea,e3edff,e2f5e9,fdf1d4,efe6ff`
                    const muted = `6b705c,a5a58d,b98b73,7c9082,8e9aaf,9c6b58`
                    const talnetAccent = '5FEAD4'
                    const greyScale = `343437,5e5e62,8c8c90,b6b6b9`
                    // const textColor = '2ED4BF' || talnetAccent
                    const textColor = talnetAccent;
                    const twSlate400to700 = '94A3B8,64748B,475569,334155'
                    const twSlate300to600 = 'CBD5E1,94A3B8,64748B,475569'
                    const twSlate400to600 = '94A3B8,64748B,475569'
                    const customBGColor1 = 'E2E8F0'

                    return `https://api.dicebear.com/10.x/initials/svg?seed=${data.organization_name}&backgroundColor=${twSlate400to600}&${textColor && `textColor=${textColor}`}&randomizeIds=true&lettersVariant=double:1`
          
               }
               else if (module === 'USER') { 
                    return (`../../../icons/user-2.png`)
               }
               
          }

     }


     const getSizeDependantClassName = (avatarFileOrURL, size) => {
          if (avatarFileOrURL) { 
               return `avatar-logo-icon-${size}`
               // if (size === 'xs') {  }
               // if (size === 'sm') { return 'avatar-logo-icon-sm' }
               // else if (size === 'md') { return 'avatar-logo-icon-md' }
               // else if (size==='lg'){ }
          }
          else if (module==='TALENT') {return `${size}`}
          else {
               return `generic-avatar-logo-icon-${size}`
               // if (size==='xs') { }
               // else if (size==='sm') { return 'generic-avatar-logo-icon-sm' }
               // else if (size==='md') { return 'generic-avatar-logo-icon-md' }
          }
     }
     return (
          <>
          {/* <div id="avatar-image" className="avatar-logo-container mx-auto m-5"> */}


{/* 
          <img src={getImageSource()} className={`editable-avatar-logo-icon ${data.avatar_file_name || data.avatar_file_url ? ('avatar-logo-icon') : ('generic-avatar-logo-icon')}`}/> */}

{/* <img src={getImageSource()} className={`avatar-logo-container-${size} rounded-full border-4 border-slate-400 
dark:border-slate-600 mx-auto ${getSizeDependantClassName(data.organization_logo_file || data.organization_logo || data.user_avatar_file || data.user_avatar, size)}`}/> */}
<img src={getImageSource()} className={`avatar-logo-container-${size} 
transition duration-300 ease-in-out
rounded-full object-cover
${size !== 'sm' && background && 'bg-gradient-to-r from-cyan-600 via-teal-400 to-teal-400' }
${(size === 'sm' || size==='md' || size==='lg' || size==='xl') && 'border p-1'} 
border-slate-200 dark:border-slate-700 ${hoverable && 'hover:border-slate-100 dark:hover:border-slate-600 cursor-pointer'}
 ${getSizeDependantClassName(data?.organization_avatar_file || data?.organization_avatar || data?.user_avatar_file || data?.user_avatar, size)}`}/>


                      {/* <img 
            src = {`${person.avatar_file_name ? (`http://localhost:8000/people-files/${person.id}/images/${person.avatar_file_name}`) : person.avatar_file_url ? (person.avatar_file_url) : person.avatar_file_url ? (person.avatar_file_url) : (`../../../icons/person.png`)}`}  
                  className={`${person.avatar_file_name || person.avatar_file_url ? ('avatar-logo-icon-small') : ('generic-avatar-logo-icon-small') }`}/> */}

          
          {/* </div> */}
          </>
     )
}

export default AvatarImage